import { Link } from 'react-router-dom';

const steps = [
  {
    num: '01',
    title: 'Contact Us',
    desc: 'Reach out by phone or email. We\'ll discuss your transaction, answer your questions, and confirm we\'re the right fit for your closing.',
  },
  {
    num: '02',
    title: 'Title Search',
    desc: 'We conduct a thorough examination of public records to verify clear ownership and identify any liens, encumbrances, or issues.',
  },
  {
    num: '03',
    title: 'Document Preparation',
    desc: 'Our team prepares all closing documents — deeds, settlement statements, title insurance commitments — well in advance of closing day.',
  },
  {
    num: '04',
    title: 'Closing Day',
    desc: 'We coordinate with all parties for a smooth, efficient closing. Most residential settlements take 1–2 hours. We handle every detail.',
  },
  {
    num: '05',
    title: 'Recording & Delivery',
    desc: 'After closing, we record the deed and mortgage with the county, issue title insurance policies, and deliver all final documents.',
  },
];

const ProcessSection = () => {
  return (
    <section className="bg-[#f7f5f0] py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-px bg-[#c9a84c]"></div>
              <span className="text-[#c9a84c] text-xs font-bold tracking-[0.3em] uppercase">How It Works</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-[#0f0f0f] leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              The Settlement<br />Process, Simplified
            </h2>
          </div>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.15em] uppercase text-[#0f0f0f] hover:text-[#c9a84c] transition-colors whitespace-nowrap cursor-pointer group shrink-0"
          >
            Get Started Today
            <div className="w-5 h-5 flex items-center justify-center border border-current rounded-full group-hover:bg-[#c9a84c] group-hover:border-[#c9a84c] group-hover:text-white transition-all">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connecting line */}
          <div className="absolute top-8 left-0 right-0 h-px bg-stone-200 hidden lg:block"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
            {steps.map((step, i) => (
              <div key={step.num} className="relative">
                {/* Number circle */}
                <div className={`w-16 h-16 flex items-center justify-center mb-6 relative z-10 ${i === 0 ? 'bg-[#c9a84c]' : 'bg-white border border-stone-200'}`}>
                  <span className={`text-sm font-black tracking-widest ${i === 0 ? 'text-[#0f0f0f]' : 'text-stone-400'}`} style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                    {step.num}
                  </span>
                </div>
                <h3 className="font-black text-[#0f0f0f] text-base mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{step.title}</h3>
                <p className="text-stone-400 text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
